import { atom, useAtom } from 'jotai';

const maxDevicesErrorAtom = atom(false);

export function useMaxDevicesError() {
  return useAtom(maxDevicesErrorAtom);
}
